var map = {
	"./logo_mottosokka02_dev.svg": 97367,
	"./logo_mottosokka02_local.svg": 91434,
	"./logo_mottosokka02_prd.svg": 30496,
	"./logo_mottosokka02_stg.svg": 70979,
	"./logo_mottosokka02_sub.svg": 71694,
	"./logo_mottosokka02_tst.svg": 8177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95169;